/**
 * Focus the top most input that is empty
 * @param htmlInputs
 */
export function focusRequiredEmptyInput(htmlInputs: HTMLInputElement[]) {
  for (const htmlInput of htmlInputs) {
    if (!htmlInput.value?.length) {
      htmlInput.focus();
      break;
    }
  }
}
